import { useLocation } from 'react-router';
import { ReactNode, useMemo } from 'react';

import { isSSG } from 'modules/common/utils/isSSG';
import { useAuth } from 'modules/auth/hooks/useAuth';

import { isInvitation } from './utils/isInvitation';
import { ConnectWalletCard } from '../ConnectWalletCard';
import { isEmailChange } from './utils/isEmailChange';

interface IAuthUserSettingsGuardProps {
  children?: ReactNode;
}

export const AuthUserSettingsGuard = ({
  children,
}: IAuthUserSettingsGuardProps) => {
  const location = useLocation();

  const { isLoggedIn } = useAuth();

  const hasInvitation = useMemo(
    () => !isSSG() && isInvitation(location),
    [location],
  );

  const isEmailConfirmation = useMemo(
    () => !isSSG() && isEmailChange(location),
    [location],
  );

  if (isLoggedIn || hasInvitation || isEmailConfirmation) {
    return <>{children}</>;
  }

  return <ConnectWalletCard />;
};
